import { ITag } from "@clickster/constant-definitions/dist-esm/entities/tag/types";
import { useMutation, useQuery } from "@tanstack/react-query";
import { IQueryProps } from "../interfaces/general/api";
import { TagService } from "../services/tags";

export const useGetTags = ({ handleSuccess, enabled, staleTime }: IQueryProps<ITag[]>) => {
    const {
        data = [],
        isLoading,
        isFetching,
        refetch,
    } = useQuery(
        ['tags-manager'],
        () =>
            TagService.getTags(),
        {
            onError: (error) => {
                console.log({ error });
            },
            onSuccess: (data: ITag[]) => {

                // Filter out deleted and inactive tags
                const dataFiltered = data.filter(tag => {
                    const isActive = tag.status === 'active';
                    const isNotDeleted = !(tag as any).deleted;
                    const shouldKeep = isActive && isNotDeleted;
                    return shouldKeep;
                });

                handleSuccess?.(dataFiltered);
            },
            retry: false,
            refetchOnWindowFocus: false,
            enabled,
            staleTime,
        },
    );

    return {
        tags: data,
        isLoading,
        isFetching,
        refetch,
    };
};

export const useCreateTag = () => {
    const { mutateAsync, isError, isLoading, isSuccess } = useMutation((tag: ITag) => TagService.createTag(tag), {
        onError: (error) => console.log({ error }),
    });

    return {
        createTag: mutateAsync,
        isError,
        isLoading,
        isSuccess,
    };
};

export const useUpdateTag = () => {
    const { mutateAsync, isError, isLoading, isSuccess } = useMutation((tag: ITag) => TagService.updateTag(tag._id!, tag), {
        onError: (error) => console.log({ error }),
    });

    return {
        updateTag: mutateAsync,
        isError,
        isLoading,
        isSuccess,
    };
};